export var FORM_SUCCESS_KEY = 'success';
export var FORM_ERROR_KEY = 'error';
export var ACCEPTED_TERMS_KEY = 'acceptedTerms';
export var CONTACT_OPT_IN_KEY = 'contactOptIn';
export var UNKNOWN_ERROR_MESSAGE = 'Unknown error sending contact form. Please try again later.';
export var DEFAULT_OPT_IN_MESSAGE = 'By entering your information, you permit us to reach out to you with future communications.';
export var REQUIRED_OPT_IN_MESSAGE = 'You must accept the terms and conditions';
export var MESSAGE_TIMEOUT = 10000;
export var CHECKED_KEY = 'checked';
export var CHECKBOX_KEY = 'checkbox';
export var DEFAULT_FORM_FIELDS = [[{
  label: 'name',
  name: 'name',
  placeholder: 'Name',
  widgetType: 'input',
  required: false
}], [{
  label: 'email',
  name: 'email',
  placeholder: 'you@gmail.com',
  widgetType: 'input',
  inputType: 'email',
  required: false
}], [{
  label: 'message',
  name: 'message',
  placeholder: 'Message',
  widgetType: 'textarea',
  required: false
}]];
export var FORM_FIELD_TYPES = {
  Input: 'input',
  Textarea: 'textarea',
  Select: 'select',
  MultiSelect: 'multiSelect',
  Checkbox: 'checkbox',
  FileUpload: 'fileUpload',
  LocationSelect: 'locationSelect'
};